import { memo } from 'react';
import { UserList } from './userlist';

export const Tracking = memo(() => {
  if (process.env.NODE_ENV !== 'production') return null;

  return (
    <>
      <UserList />
    </>
  )
});